<template>
  <div class="storage-estimate-container" :class="{ padding: this.step === 1 }">
    <SwipeBanner containerClass="estimate-ads tablet-hide" :items="bannerItems">
      <template v-slot="{ index }">
        <!-- Your custom banner content here -->
        <div v-if="index === 0" class="banner-1">
          <div class="badge-row">
            <CircleBadge>#무신사</CircleBadge>
            <CircleBadge>#무신사제휴</CircleBadge>
          </div>

          <div class="title">
            <span class="black-highlight">musinsa studio</span>와<br>
            <img src="~assets/img/logo_ko_bob_black.svg" alt="밥아저씨" class="logo-ko-bob">가 함께합니다.
          </div>

          <div class="desc-guide">
            * 무신사 스튜디오라면 어느지점이든 관계 없습니다.
          </div>

          <img class="img-character" src="~/assets/img/banner_1.svg">
        </div>
        <div v-else-if="index === 1" class="banner-2">
          <div class="banner-row">
            <CircleBadge badge-style="yellow-badge">#보관서비스</CircleBadge>
            <CircleBadge badge-style="yellow-badge">#월구독료 2,500</CircleBadge>
          </div>

          <div class="title">세상에서 가장 투명하고<br>정직한 박스단위<br> 물류 서비스</div>
          <img class="img-character" v-lazy="require('@/assets/img/banner_2.svg')">
        </div>
        <div v-else-if="index === 2" class="banner-3">
          <div class="badge-row">
            <CircleBadge>#보관서비스</CircleBadge>
            <CircleBadge>#월구독료 2,500</CircleBadge>
          </div>
          <div class="title">투명하고 정직한 가격의 보관서비스를 지금 바로 경험하세요!</div>

          <img v-lazy="require('@/assets/img/img_brand_1.svg')">
        </div>
      </template>
    </SwipeBanner>
<!--    <div class="estimate-ads tablet-hide">-->
<!--      <div class="hashtag">-->
<!--        <span>#보관서비스</span>-->
<!--        <span>#월구독료 2,500</span>-->
<!--      </div>-->

<!--      <div class="ads-title">투명하고 정직한 가격의 보관서비스를 지금 바로 경험하세요!</div>-->

<!--      <img src="~assets/img/img_brand_1.svg">-->
<!--    </div>-->

    <!--  견적 입력 단계  -->
    <div class="estimate-form" v-if="step === 1">
      <div class="relative">
        <div class="title-wrap" v-if="isEventEntered">
          <BubbleLabel title="Free"/>
          <div class="estimate-title">3개월 무료 이벤트</div>
        </div>
        <div class="title-wrap" v-else>
          <BubbleLabel title="Quick"/>
          <div class="estimate-title">내 맘대로 PLAN</div>
        </div>

        <div class="relative tablet-show text-right">
          <img src="~/assets/img/floating_box.svg" class="img-mobile-bob">
<!--          <img v-lazy="require('@/assets/img/character/bob_mobile_main.svg')" class="img-mobile-bob">-->
        </div>
      </div>

      <div class="box-container">
        <StorageBoxSelectV2 class="relative" :disabled="isEventEntered" v-model="estimate_data.box_cnt"/>
        <div class="period-wrap">
          <StoragePeriodV2 ref="periodComponent" :disabled="isEventEntered" v-model="estimate_data.period" :isMobile="isMobile">
            <div v-if="result.subscribe_price !== null" class="estimate-result-wrap">
              <div class="result-row">
                <label for="subscribe_price">월 결제 요금</label>
                <div id="subscribe_price" class="float-right">
                  <span class="price">{{ this.$helper.getMoneyStr(getSubscribePrice) }}</span>
                </div>
              </div>

              <div class="price-guide text-right">{{ estimate_data.period }}개월 보관 기간 동안 총비용 {{ $helper.getMoneyStr(getSubscribePrice * estimate_data.period) }}원</div>
            </div>
          </StoragePeriodV2>
        </div>
      </div>


      <button class="btn btn-lg btn-block btn-primary mt-4 btn-delivery" @click="clickDeliveryStepBtn">배송정보 입력하기</button>

      <!--   배송정보 입력 팝업   -->
      <TheEstimateDeliveryPopupV2
          ref="deliveryPopupV2"
          v-model:box_cnt="estimate_data.box_cnt"
          v-model:address="estimate_data.address"
          v-model:address_detail="estimate_data.address_detail"
          v-model:address_sigungu="estimate_data.address_sigungu"
          v-model:address_bname="estimate_data.address_bname"
          v-model:address_zipcode="estimate_data.address_zipcode"

          v-model:delivery_date="estimate_data.delivery_date"
          v-model:delivery_time="estimate_data.delivery_time"
          v-model:collection_date="estimate_data.collection_date"
          v-model:collection_time="estimate_data.collection_time"
          :onOrderComplete="showOrderConfirm"
          :showAddressModal="showAddressModal"
      ></TheEstimateDeliveryPopupV2>
      <TheAddressModal type="load" :isHideFloor="true" ref="addressModal" :onSelectedAddress="onSelectedAddress"></TheAddressModal>
    </div>

    <!--   주문환인 및 결제 단계   -->
    <div class="order-confirm" v-else-if="step === 2">
      <div class="relative">
        <BubbleLabel title="Order"/>
        <div class="estimate-title">주문확인·결제</div>
      </div>

      <div class="card">
        <div class="order-row">
          <div class="label">보관 박스 개수</div>
          <div class="content">{{ estimate_data.box_cnt }}개</div>
        </div>
        <div class="order-row">
          <div class="label">보관 기간</div>
          <div class="content">{{ estimate_data.period }}개월</div>
        </div>
        <div class="order-row">
          <div class="label">주소</div>
          <div class="content">{{ estimate_data.address }}<br>{{ estimate_data.address_detail }}</div>
        </div>
        <div class="order-row">
          <div class="label">빈 박스 수령일</div>
          <div class="content">{{ estimate_data.delivery_date }} {{ estimate_data.delivery_time }}</div>
        </div>
        <div class="order-row">
          <div class="label">박스 수거일</div>
          <div class="content">{{ estimate_data.collection_date }} {{ estimate_data.collection_time }}</div>
        </div>
      </div>

      <div class="card card-border price-card">
        <div class="price-row">
          <div class="label highlight-txt">월 자동 결제 요금</div>
          <div class="content highlight-txt">
            {{ $helper.getMoneyStr(result.subscribe_price) }}원
            <div class="guide">{{ estimate_data.period }}개월 보관 기간 동안 총 비용 {{ $helper.getMoneyStr(result.subscribe_price * estimate_data.period) }}원</div>
          </div>
        </div>


        <div v-if="result.delivery_price" class="price-row">
          <div class="label highlight-txt">배송요금</div>
          <div class="content highlight-txt">
            {{ $helper.getMoneyStr(result.delivery_price) }}원
            <div class="guide">조금만 노력하면 아낄 수 있는 금액이예요!</div>
          </div>
        </div>

        <div v-if="result.discount_price" class="price-row">
          <div class="label highlight-txt">할인요금</div>
          <div class="content highlight-txt">
            {{ $helper.getMoneyStr(result.discount_price) }}원
            <div class="guide">쿠폰이 적용된 할인 금액이에요</div>
          </div>
        </div>

        <div class="price-row total-price-row">
          <div class="label highlight-txt">총 결제 요금</div>
          <div class="content">
            {{ $helper.getMoneyStr(result.real_amount) }}원
          </div>
        </div>
      </div>

      <div v-if="this.myPayments && this.myPayments.length > 0 && !isEventEntered" class="card payment-card">
        <TheEstimatePaymentV2 :payments="myPayments" :type="paymentType" v-model="paymentId"></TheEstimatePaymentV2>
      </div>
      <TheEstimateStorageDamage ref="storageAgreement"></TheEstimateStorageDamage>
      <button class="btn btn-lg btn-block btn-primary mt-4 btn-delivery" @click="runPayment">결제하기</button>
    </div>
  </div>
</template>

<script>
import _CONST from "@/store/const";
import StorageBoxSelectV2 from "@/components/estimate/StorageBoxSelectV2";
import StoragePeriodV2 from "@/components/estimate/StoragePeriodV2";
import BubbleLabel from "@/components/label/BubbleLabel";
import TheEstimateDeliveryPopupV2 from "@/components/estimate/TheEstimateDeliveryPopupV2";
import TheEstimatePaymentV2 from "@/components/estimate/TheEstimatePaymentV2";
import TheAddressModal from "@/components/TheAddressModal";
import TheEstimateStorageDamage from "@/components/estimate/TheEstimateStorageDamage";
import SwipeBanner from "@/components/SwipeBanner";
import CircleBadge from "@/components/CircleBadge";

import apiStorage from "@/api/storage";
import apiUser from "@/api/user";

export default {
  name: "TheStorageEstimateV2",
  components: {
    TheEstimateStorageDamage,
    StorageBoxSelectV2,
    StoragePeriodV2,
    BubbleLabel,
    TheEstimateDeliveryPopupV2,
    TheEstimatePaymentV2,
    TheAddressModal,
    SwipeBanner,
    CircleBadge
  },
  props: ['isMobile'],
  watch: {
    'estimate_data.box_cnt'() {
      if (this.estimate_data.box_cnt) {
        this.estimate_data.box_cnt = Number(this.estimate_data.box_cnt);
      }
    },
    // 'estimate_data.period'() { this.updatePrice(); },
  },
  computed: {
    getSubscribePrice() {
      if (this.isEventEntered) {
        return 0;
      }

      let type = 'MONTH12';

      if (this.estimate_data.period < 6) {
        type = 'DEFAULT';
      } else if (this.estimate_data.period < 12) {
        type = 'MONTH6';
      }

      return this.contract_price[type] * this.estimate_data.box_cnt;
    },

  },
  data() {
    return {
      isEventEntered: false,
      step: 1,
      bannerItems: [{
        img: '~assets/img/banner_1.svg',
      }, {
        img: '~assets/img/banner_2.svg',
      }, {
        img: '~assets/img/img_brand_1.svg',
      }],
      paymentType: _CONST.PAYMENT_TYPE.ONLY_SUBS_PAYMENT,
      estimate_data: {
        box_cnt: 1,
        period: 12,
        address: null,
        address_detail: null,
        address_sigungu: null,
        address_bname: null,
        address_zipcode: null,
        delivery_date: null,
        delivery_time: 'none',
        collection_date: null,
        collection_time: 'none',
        us_cp_id: null
      },
      paymentId: null,
      result: {
        subscribe_price: 2500,
        delivery_price: null,
        discount_price: null
      },
      contract_price: {},
      modal: {
      },
      myPayments: null,
      agreement: false
    }
  },
  methods: {
    // handleDeliveryDateUpdate(newValue) {
    //   this.estimate_data.delivery_date = dayjs(newValue).format('YYYY-MM-DD');
    // },
    // handleCollectionDateUpdate(newValue) {
    //   this.estimate_data.collection_date = dayjs(newValue).format('YYYY-MM-DD');
    // },
    showAddressModal() {
      this.$refs.addressModal.showAddressModal();
    },
    onSelectedAddress(addressData) {
      this.estimate_data.address = addressData.address;
      this.estimate_data.address_detail = addressData.address_detail;
      this.estimate_data.address_sigungu = addressData.address_sigungu;
      this.estimate_data.address_bname = addressData.address_bname;
      this.estimate_data.address_zipcode = addressData.address_zipcode;
      // this.estimate_data.address_floor = addressData.address_floor;
      this.$refs.addressModal.closeListModal();
    },
    async runPayment() {
      if (!this.$refs.storageAgreement.agreement) return alert("이용 규정을 확인해주세요.");

      /* 3개월 이벤트 */
      if (this.isEventEntered) {
        try {
          await apiStorage.addContractV2ForEvent({
            ...this.estimate_data
          });
        } catch (e) {
          alert(e?.response?.data?.message || "이벤트 신청에 실패했습니다.");
          return;
        }

        alert("예약되었습니다.");
        this.$router.push('/my');
        return;
      }

      if (!this.myPayments || this.myPayments.length === 0) {
        await this.requestOrder();
      } else {
        if (!this.paymentId) return alert("결제수단을 선택해주세요.");
        await apiStorage.addContractV2({
          ...this.estimate_data,
          payment_id: this.paymentId
        });

        alert("예약되었습니다.");
        this.$router.push('/my');
      }
    },

    /**
     * 보관 주문 신청
     * @returns {Promise<void>}
     */
    async requestOrder() {
      try {
        let { serial, real_amount } = await apiStorage.addContractV2(this.estimate_data);

        if (real_amount > 0) {
          // window.fbq && window.fbq('track', 'Purchase', {currency: 'KRW', value: real_amount});
          this.requestPay({
            name: 'BOB 보관 결제',
            amount: real_amount,
            merchant_uid: serial,
            buyer_name: this.$store.state.auth.profile.name,
            buyer_tel: this.$store.state.auth.profile.phone_number,
            buyer_email: this.$store.state.auth.profile.email || '',
            customer_uid: this.$store.state.auth.profile.id,
            customer_id: this.$store.state.auth.profile.username
          });
        } else {
          // window.fbq && window.fbq('track', 'Purchase', {currency: 'KRW', value: 0});
          alert("예약되었습니다.");
          this.$router.push('/my');
        }
      } catch (e) {
        if (e.response) {
          alert(e.response.data.message);
        }
      }
    },
    async requestPay(obj) {
      this.$helper.loadIamportScript(() => {
        const { IMP } = window;
        IMP.init(_CONST.PAYMENT.USERCODE);

        let data = {
          pg: this.$helper.isDev() ? 'tosspayments.iamporttest_4' : _CONST.PAYMENT.BILLING,
          pay_method: 'card',
          merchant_uid: obj.merchant_uid,
          amount: obj.amount,
          name: obj.name,
          buyer_email: obj.buyer_email,
          buyer_name: obj.buyer_name,
          buyer_tel: obj.buyer_tel,
          m_redirect_url: this.$helper.getUrl('/storage/payment/complete/mobile'),
          customer_uid: obj.customer_uid + '_' + obj.merchant_uid,
          customer_id: obj.customer_id
        };

        // console.log(data);
        IMP.request_pay(data, this.callback);
      });
    },


    async callback(rsp) {
      if (rsp.success) {
        let result = {
          imp_uid: rsp.imp_uid,
          merchant_uid: rsp.merchant_uid,
          customer_uid: rsp.customer_uid
        }

        try {
          await apiStorage.paymentCompleteV2(result);
          alert("결제되었습니다.")

          this.$router.push('/my');
        } catch (e) {
          if (e.response.data.message) {
            alert(e.response.data.message);
          }
        }
      } else {
        alert("결제에 실패했습니다.");
        try {
          // console.log(rsp);
          await apiStorage.deleteEstimateV2(rsp.merchant_uid);
        } catch (e) {
          console.log(e);
        }
      }
    },

    /**
     * 주문확인 페이지로 이동.
     * @returns {Promise<void>}
     */
    async showOrderConfirm() {
      if (!this.estimate_data.address) return alert("주소를 입력해주세요");
      if (!this.estimate_data.delivery_date || this.estimate_data.delivery_time === 'none') return alert("배송일시를 확인해주세요");
      if (!this.estimate_data.collection_date || this.estimate_data.collection_time === 'none') return alert("수거일시를 확인해주세요");

      this.$refs.deliveryPopupV2.close();
      if (this.$store.state.auth.isLogin) {
        this.myPayments = await apiUser.getPaymentList();
        await this.updatePrice();
        this.step = 2;
        // this.$router.push({ path: '/' });
      } else {
        localStorage.setItem('storage_order_for_login', JSON.stringify(this.estimate_data));
        this.$router.push({ path: '/login', query: { redirect: '/', param: 'step2' } });
      }
    },

    clickDeliveryStepBtn() {
      this.$refs.deliveryPopupV2.open();
    },

    /** 견적 금액 로드 */
    async updatePrice() {
      if (this.isEventEntered) {
        this.result.subscribe_price = 0;
        this.result.real_amount = 0;
        return;
      }

      let  { real_amount, subscribe_amount, discount_amount, us_cp_id } = await apiStorage.getOrderPrice(_CONST.STORAGE_ORDER_TYPE.FIRST_TIME_ORDER, {
        period: this.estimate_data.period,
        box_cnt: Number(this.estimate_data.box_cnt)
      });

      this.result.subscribe_price = subscribe_amount;
      this.result.real_amount = real_amount;
      this.result.discount_price = discount_amount;

      if (us_cp_id) {
        this.estimate_data.us_cp_id = us_cp_id;
      }
    },

    handleBack(e) {
      if (this.step > 1) {
        e.preventDefault();
        e.stopPropagation();
        this.step --;
        this.$router.push({ path: '/'});
        // window.history.pushState({ step: this.step }, '');
        return false;
      }
    },

    setVhSize() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },

    loadDataForLogin() {
      if (this.isEventEntered) {
        this.estimate_data.period = 3;
        return;
      }
      let data = localStorage.getItem('storage_order_for_login');

      if (data) {
        // console.log(data);
        localStorage.removeItem('storage_order_for_login');
        this.$route.query = null;

        this.estimate_data = JSON.parse(data);
        this.step = 2;

        if (!data) return;
        return data;
      }

      return null;
    }
  },



  async mounted() {
    await this.updatePrice();
    this.contract_price = await apiStorage.getContractPrice();

    window.addEventListener('popstate', this.handleBack);

    this.setVhSize()

    if (this.$store.state.auth.isLogin) {
      this.myPayments = await apiUser.getPaymentList();
    }
    // window.addEventListener('resize', this.setVhSize);

  },


  beforeUnmount() {
    // 컴포넌트가 소멸되기 전에 이벤트 리스너 제거
    window.removeEventListener('popstate', this.handleBack);
    // window.removeEventListener('resize', this.setVhSize);
  },



  async beforeMount() {
    if (this.$route.meta?.['enter_type'] === 'event3') {
      this.isEventEntered = true;
    }

    this.loadDataForLogin();
  },
}
</script>

<style scoped lang="scss">
  .storage-estimate-container {
    option:disabled {
      color: #b1b1b1;
    }

    .period-wrap {
      background-color: #fff;
      border-radius: 10px;
      padding: 30px 45px;
    }

    .estimate-ads {
      position: relative;
      flex: 1 0;
      padding: 0;
      border-radius: 20px;
      margin-right: 35px;
      overflow: hidden;
    }

    .ads-title {
      font-size: 38px;
      font-weight: 900;
      line-height: 52px;
      padding-top: 30px;
      word-break: keep-all;
    }

    .bubble-label {
      margin-bottom: 5px;
    }

    .estimate-title {
      font-size: 35px;
      line-height: 51px;
      padding-top: 4px;
      padding-bottom: 30px;
      font-weight: 900;
      letter-spacing: -0.35px;
    }

    .img-mobile-bob {
      //position: absolute;
      width: 167.43px;
      height: 94.06px;
      margin-right: -23px;
    }

    .estimate-result-wrap {
      padding-top: 40px;
    }

    .result-row {
      border-top: 1px solid #000;
      border-bottom: 1px solid #000;
      height: 70px;
      line-height: 70px;
      font-weight: 900;
      padding: 0 20px;

      label {
        font-size: 17px;
      }

      span.price {
        display: inline-block;
        color: $sub-color;
        font-size: 35px;
        line-height: 35px;
        margin-top: 15px;
        vertical-align: top;

        &::after {
          content: '원';
          color: #000;
          font-size: 17px;
          font-weight: normal;
        }
      }
    }

    .price-guide {
      color: #AAAEB6;
      font-size: 14px;
      font-weight: bold;
      line-height: 30px;
      display: inline-block;
      width: 100%;
    }

    .order-confirm {
      width: 650px;

      .card {
        background-color: #fff;
        border-radius: 10px;
        padding: 30px 50px;
        font-size: 15px;
        line-height: 21px;

        &:not(.payment-card) {
          text-align: right;
        }


        .order-row {
          & + .order-row {
            margin-top: 10px;
          }
        }

        .price-row {
          & + .price-row {
            margin-top: 13px;
          }

          &.total-price-row {
            border-top: 1px solid #000;
            margin-top: 20px;
            line-height: 65px;

            .content {
              color: $sub-color;
              font-size: 28px;
              font-weight: 900;
            }
          }
        }

        .label {
          font-weight: 900;
          float: left;
          color: #AAAEB6;
        }

        .content {
          font-weight: bold;
        }

        &.price-card {
          border: 1px solid #000;
          margin-top: 20px;
          line-height: 25px;
          margin-bottom: 20px;
          padding-bottom: 15px;

          .highlight-txt {
            font-size: 17px;
            color: #000;
            font-weight: 900;
          }

          .guide {
            font-size: 14px;
            color: #AAAEB6;
            font-weight: bold;
            line-height: 20px;
          }
        }

        &.payment-card {
          margin-bottom: 15px;
        }
      }
    }

    @include respond(desktop) {
      display: flex;

      .period-wrap {
        min-height: 491px;
      }

      .estimate-form {
        width: 650px;
      }
    }

    @include respond(tablet) {
      &.padding {
        //padding-top: 13vh !important;
      }

      .box-container {
        background-color: #fff;
        border-radius: 10px;
        //padding: 30px 45px;
      }

      .period-wrap {
        padding: 15px;
      }

      .title-wrap {
        position: absolute;
        bottom: 0;
      }

      .order-confirm {
        width: 100%;
      }

      .card {
        padding: 20px 30px;
      }

      .img-mobile-bob {
        right: -30px;
      }

      .estimate-title {
        font-size: 24px;
        line-height: 40px;
        padding-bottom: 15px;
        padding-top: 0;
      }

      .estimate-result-wrap {
        padding-top: 30px;

        .result-row {
          height: 52px;
          line-height: 52px;
          padding: 0;
        }

        label {
          font-size: 14px;
        }

        span.price {
          font-size: 25px;
          line-height: 25px;
          margin-top: 10px;

          &::after {
            font-size: 12px;
          }
        }

        .price-guide {
          font-size: 10px;
          line-height: 20px;
        }
      }
    }

    @include respond(mobile) {
      //&.padding {
      //  padding-top: 5vh;
      //}

      .period-wrap {
        min-height: 280px;
      }

      .img-mobile-bob {
      }

      .box-container {
        padding: 20px 15px;
      }

      .box-wrap {
        padding: 15px 0 0;
      }

      .period-wrap {
        padding: 20px 0 0;
      }
    }

    @include respond(xs-mobile) {

      .img-mobile-bob {
      }

      .estimate-title {
        font-size: 23px;
        line-height: 1.3;
        padding-bottom: 10px;
      }

      .box-container {
        padding: 15px;
      }
    }

    @include respond(sm-height-tablet) {
      .estimate-result-wrap {
        padding-top: 20px;
      }

      //.img-mobile-bob {
      //  right: -3%;
      //  width: 90%;
      //}
    }

    @include respond(lg-height-tablet) {
      //.period-wrap {
      //  padding: 25px;
      //}
    }
  }
</style>

<style lang="scss">
.main-panel.Home {
  .main-content.main {
    align-items: center;
  }

  &.ios-app {
    .main-content.main {
      padding-top: 50px;
    }
  }
}

.storage-estimate-container {
  .period-wrap {
    margin-top: 20px;
  }

  @include respond(tablet) {
    .period-wrap {
      margin-top: 15px;
    }
  }

  @include respond(sm-height-tablet) {
    .period-wrap {
      margin-top: 10px;
    }

    .btn-delivery {
      margin-top: 10px !important;
    }
  }

  .banner-item {
    padding: 65px 50px;
    height: 100%;
    background-color: $main-color;

    &.banner-item-2 {
      background-color: #fff;
    }

    .title {
      font-size: 38px;
      font-weight: 800;
      line-height: 52px;
      margin-top: 45px;
    }

    .img-character {
      position: absolute;
      bottom: 0;
      left: 0;
      max-width: 100%;
    }
  }

  .banner-1 {
    .title {
      text-align: right;

      .black-highlight {
        display: inline-block;
        background-color: #000;
        color: #fff;
        padding: 0 15px 4px;
        line-height: 46px;
        margin-right: 3px;
        border-radius: 13px;
        font-weight: normal;
      }

      img {
        height: 33px;
        margin-bottom: -2px;
        margin-right: 4px;
      }
    }

    .desc-guide {
      color: rgba(0, 0, 0, 0.6);
      font-size: 18px;
      text-align: right;
      padding-top: 25px;
    }

    .img-character {
      width: 100%;
    }
  }

  .banner-2 {
    .title {
      margin-top: 40px;
    }

    .img-character {
      width: 430px;
      max-width: 85%;
      bottom: 75px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .banner-3 {
    white-space: initial;
    padding-right: 20px;

    img {
      position: absolute;
      bottom: -7px;
      left: 50%;
      transform: translate(-50%, 0);
      max-width: 26vw;
      max-height: 55%;
    }
  }

  @include respond(not-md-desktop) {
    .banner-item {
      padding: 65px 30px;

      .title {
        font-size: 26px;
        line-height: 40px;
      }
    }

    .banner-1 {
      .title img {
        height: 22px;
        margin-bottom: -1px;
        margin-right: 1px;
      }

      .desc-guide {
        white-space: initial;
        line-height: 1.5;
      }
    }
  }
}
</style>
